const articles = [
    {
        name: 'learn-this',
        title: 'Start With Why',
        content: [
            'Years ago, I read a great book called Start With Why, written by a fellow by the name of Simon Sinek. It\'s an excellent, well-written book that covers a lot of topics that leaders can use to be more effective. The overall concept is to think about WHY any decision, project, or even company exists.',
            'I won\'t reveal all of Mr. Sinek\'s secrets (seriously, it\'s an excellent book - I highly endorse buying a copy), but deciding to make a huge change in my career path really, really had to have the WHY defined. I was surely going to be asked this a lot in interviews.',
            '"https://simonsinek.com/product/start-with-why/"'
        ]
    },
    {
        name: 'another-thing',
        title: 'This is the Title of the Second Article',
        content: [
            'You are looking at the second article.',
            'This is the second paragraph in the second article.'
        ]
    },
    {
        name: 'yet-another-thing',
        title: 'This is the Title of the Third Article',
        content: [
            'You are looking at the third article.',
            'This is the second paragraph in the third article.'
        ]
    }
];

export default articles;